module.exports = __webpack_public_path__ + "static/media/blueParrot.7fcfa042.png";